import { useCallback, useMemo } from 'react'

import type { TMarkerResponse } from '@/entities/map'

import {
  useLandmarkOverlay,
  useRegionOverlay,
  useRoomCountOverlay,
  useRoomOverlay,
  useSubwayOverlay,
} from '../overlay'

export const useOverlays = () => {
  const regionOverlay = useRegionOverlay()
  const subwayOverlay = useSubwayOverlay()
  const landmarkOverlay = useLandmarkOverlay()
  const roomOverlay = useRoomOverlay()
  const roomCountOverlay = useRoomCountOverlay()

  const clearOverlays = useCallback(() => {
    regionOverlay.clear()
    subwayOverlay.clear()
    landmarkOverlay.clear()
    roomOverlay.clear()
    roomCountOverlay.clear()
  }, [
    regionOverlay,
    subwayOverlay,
    landmarkOverlay,
    roomOverlay,
    roomCountOverlay,
  ])

  const updateOverlays = useCallback(
    (
      markers: TMarkerResponse,
      { resetRoom = true }: { resetRoom?: boolean } = {},
    ) => {
      landmarkOverlay.update(markers.landmarkMarkers)
      subwayOverlay.update(markers.subwayMarkers)
      regionOverlay.update(markers.regionMarkers)
      roomOverlay.update(markers.roomMarkers, { reset: resetRoom })
      roomCountOverlay.update(markers.roomCountMarkers, { reset: resetRoom })
    },
    [
      regionOverlay,
      subwayOverlay,
      landmarkOverlay,
      roomOverlay,
      roomCountOverlay,
    ],
  )

  const overlays = useMemo(
    () => ({
      clear: clearOverlays,
      update: updateOverlays,
    }),
    [clearOverlays, updateOverlays],
  )

  return overlays
}
